import { render, staticRenderFns } from "./InstitutionView.vue?vue&type=template&id=892ca002&"
import script from "./InstitutionView.vue?vue&type=script&lang=js&"
export * from "./InstitutionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports